import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { removeEmpty, useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';

import { dealTransformer } from '../transformer';
import c from '../utils/constants';

export default function useGetDealsList(
  params: { pipelineId?: string; companyId?: string } = {},
) {
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;

  return useQuery({
    queryKey: [c.PIPELINES, params?.pipelineId, c.DEALS, c.LIST, params],
    queryFn: async () => {
      const api = new Api(args);

      const data: ReturnType<typeof dealTransformer.dealsList> = await api.get(
        await withAcl({
          account: {
            url: 'api/v1/sales/deals',
            params: removeEmpty({ ...params, include: ['company', 'lead'] }),
            transformer: dealTransformer.dealsList,
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/sales/deals`,
            params: removeEmpty({ ...params, include: ['company', 'lead'] }),
            transformer: dealTransformer.dealsList,
          },
        }),
      );

      return data.data;
    },
    enabled: !!params.pipelineId,
  });
}
